import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      padding: '0px!important',
    },
    bannerMainSegments: {
      width: '100%',
      maxWidth: 663,
      borderRadius: 10,
    },
    gridMainSegments: {
      margin: '6px 10px!important',
      border: '1px solid #e5e5e5',
      borderRadius: 10,
      maxWidth: 663,
      cursor: 'pointer',
    },
    girdTitleSegments: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left',
      width: '100%',
      marginBottom: '5px',
      paddingLeft: 10,
    },
    textTitleSegments: {
      fontSize: 14,
      color: '#8c4b3e',
      margin: '0px 0px 0px 5px!important',
    },
    gridShop: {
      [theme.breakpoints.down('sm')]: {
        height: 100,
      },
      [theme.breakpoints.down('xs')]: {
        height: 'auto',
      },
      marginTop: '10px!important',
      marginRight: '10px!important',
      marginLeft: '10px!important',
      border: '1px solid #e5e5e5',
      borderRadius: 10,
      padding: 5,
      height: 125,
      width: '100%!important',
      cursor: 'pointer',
    },
    titleNotFoundShop: {
      color: '#e57f59',
      margin: 10,
      borderRadius: 10,
      background: '#e7e7e76b',
      borderBottom: 'solid 1px #dfdede',
    },
    gridProduct: {
      borderBottom: '1px solid #efefef',
      borderRadius: 10,
      padding: 5,
      cursor: 'pointer',
      width: '100%!important',
    },
    gridDesProduct: {
      [theme.breakpoints.down('sm')]: {
        minHeight: 70,
      },
      minHeight: 95,
    },
    gridCategorie: {
      color: '#32353a',
      backgroundColor: '#fef2f2',
      padding: '3px 0px 3px 30px',
    },
    titleCategorie: {
      margin: '0px!important',
    },
    titleShop: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.9em',
      },
      margin: '0px!important',
      color: '#33373c',
      textAlign: 'left',
      fontWeight: 500,
      fontSize: '1.11em',
    },
    textShop: {
      color: '#929292',
      textAlign: 'left',
      fontSize: 12,
      padding: '2px 2px!important',
      margin: '0px!important',
    },
    textShopCoupom: {
      background: '#dadfea',
      color: '#97a7ae',
      textAlign: 'left',
      fontSize: 12,
      padding: '0px 3px!important',
      borderRadius: 4,
      margin: '0px!important',
    },
    bannerShop: {
      [theme.breakpoints.down('sm')]: {
        width: 70,
        height: 70,
      },
      width: 95,
      height: 95,
      borderRadius: 10,
      objectFit: 'cover',
    },
    textTagLive: {
      margin: '0px 0 5px 0!important',
      backgroundColor: '#298000',
      borderRadius: 5,
      padding: '0px 10px',
      color: '#fff',
      alignItems: 'center',
      textTransform: 'uppercase',
      fontWeight: 550,
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      fontSize: 12,
    },
    titleProduct: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.8em',
      },
      margin: '0px!important',
      color: '#33373c',
      textAlign: 'left',
      fontSize: '1.01em',
      wordWrap: 'break-word',
    },
    titlePromotion: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.8em',
      },
      margin: '0px 3px 0px 0px!important',
      color: '#33373c',
      textAlign: 'left',
      fontSize: '1.01em',
      wordWrap: 'break-word',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    textProduct: {
      color: '#929292',
      textAlign: 'left',
      fontSize: 12,
      wordWrap: 'break-word',
      margin: '0px!important',
    },
    textDesValue: {
      margin: '0px!important',
      fontSize: 14,
      color: '#929292',
    },
    textValue: {
      margin: '0px 5px 0px 5px!important',
      fontWeight: 550,
      color: '#b5423f',
      fontSize: 14,
    },
    gridStart: {
      display: 'flex',
      width: 60,
      backgroundColor: '#fff5c7',
      height: 25,
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      borderRadius: 5,
    },
    iconStart: {
      width: 15,
      height: 15,
      marginRight: 5,
    },
    gridFavorite: {
      width: '100%',
      justifyContent: 'center',
    },
    iconFavorite: {
      width: 20,
      height: 18,
      margin: '15px 0 0 5px',
    },
    textStart: {
      margin: '0px!important',
      color: '#ffbe63',
      fontSize: 12,
    },

    gridAboutMain: {
      padding: '0px 0',
      borderRadius: 10,
      marginLeft: '5px!important',
    },
    gridAbout: {
      alignItems: 'center',
      marginRight: '5px!important',
    },
    textAbout: {
      margin: '0px!important',
      fontSize: 13,
      marginRight: '5px!important',
      color: '#35383d',
    },

    gridRatingMain: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '89%',
      height: 40,
      backgroundColor: '#fff5c7',
      borderRadius: 10,
      padding: '0 5px',
    },
    gridRating: {
      display: 'flex',
      alignItems: 'center',
    },
    textRating: {
      margin: '0px!important',
      marginRight: '5px!important',
      color: '#6d6d61',
      fontSize: 12,
    },
    textRatingBold: {
      margin: '0px!important',
      fontSize: 12,
      color: '#292d32',
      fontWeight: 550,
    },
    textSeparator: {
      color: '#ffcd7c',
    },
    lineRating: {
      borderBottom: '1px solid #f7f7f7',
      width: '60%!important',
      margin: '10px 0',
      borderRadius: 10,
    },
    gridComment: {
      border: '1px solid #e5e5e5',
      borderRadius: 10,
      padding: 5,
      margin: '5px 0',
      display: 'flex',
      width: '85%!important',
    },
    bannerProfileComment: {
      width: 55,
      height: 55,
      borderRadius: 55,
      objectFit: 'cover',
      margin: 10,
    },
    textNameComment: {
      color: '#484b4f',
      margin: '0px!important',
      fontSize: 12,
      fontWeight: 300,
    },
    textDesComment: {
      color: '#666666',
      fontSize: 11,
      margin: '0px!important',
    },
    gridResponse: {
      background: '#e3e0e0c7',
      padding: 5,
      borderRadius: 10,
    },
    titleResponse: {
      color: '#000',
      fontSize: 11,
      fontWeight: 600,
      margin: '0px!important',
    },
    gridStarComment: {
      display: 'flex',
      height: 24,
      justifyContent: 'center',
      width: 55,
      backgroundColor: '#fff5c7',
      alignItems: 'center',
      padding: 5,
      borderRadius: 10,
    },
    textNoteComment: {
      margin: 0,
      fontSize: 12,
      marginLeft: 4,
      color: '#ffc065',
    },

    gridAbountMain: {
      alignItems: 'center',
      width: '85%!important',
      display: 'flex',
      justifyContent: 'space-between',
    },
    gridAbount: {
      alignItems: 'center',
      display: 'flex',
    },
    titleAbount: {
      marginLeft: '5px!important',
      margin: '0px!important',
      fontSize: '1.01em',
    },
    textBtnLocationMap: {
      textTransform: 'none',
      color: '#b6423f',
      margin: '0px!important',
    },
    textDesLocation: {
      width: '85%',
      padding: '0px 22px!important',
      color: '#444',
      fontSize: 12,
      margin: '0px!important',
    },

    textDesFormatPayment: {
      marginLeft: '5px!important',
      color: '#444',
      fontSize: 12,
      margin: '0px!important',
    },

    titleDayOperation: {
      marginLeft: '5px!important',
      color: '#444',
      fontSize: 12,
      margin: '0px!important',
      fontWeight: 550,
      width: '128px',
    },

    textHoursOperation: {
      marginLeft: '5px!important',
      color: '#444',
      fontSize: 12,
      margin: '0px!important',
    },

    gridSegments: {
      marginTop: '10px!important',
      border: '1px solid #e5e5e5',
      borderRadius: 10,
      padding: '5px  5px 0',
      width: '85%!important',
      cursor: 'pointer',
    },
    bannerSgments: {
      [theme.breakpoints.down('xs')]: {
        width: 70,
        height: 70,
      },
      width: '100%',
      height: '100%',
      borderRadius: 10,
      objectFit: 'cover',
    },
    titleSegments: {
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.0em',
      },
      margin: '0px!important',
      color: '#908989',
      textAlign: 'left',
      fontSize: '1.11em',
    },
    gridViewPlus: {
      display: 'flex',
      width: 50,
      backgroundColor: '#f18b03',
      height: 23,
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      borderRadius: 5,
    },
    textViewPlus: {
      margin: '0px!important',
      color: '#fefefe',
      fontSize: 10,
    },

    btnSubmit: {
      textTransform: 'uppercase',
      margin: '10px 0!important',
      backgroundColor: '#a51713!important',
      width: '100%',
      borderRadius: '10px!important',
    },
    btnSaq: {
      backgroundColor: '#fbd3d3!important',
      width: '100%',
      marginTop: '20px!important',
      marginLeft: '10px!important',
      marginRight: '10px!important',
    },
    btnTextSaq: {
      margin: '0px!important',
      fontSize: 13,
      textTransform: 'none',
      color: '#c35855',
    },
    titleModal: {
      textTransform: 'uppercase',
      margin: '10px 0!important',
    },
    textModal: {
      textAlign: 'center',
      marginBottom: '15px!important',

      color: '#a8a8a8',
    },
    iconModal: {
      width: 60,
      height: 60,
    },
    btnModal: {
      margin: '10px 0!important',
      backgroundColor: '#a51713!important',
      bottom: '0px!important',
      maxWidth: 680,
      width: '70%',
      borderRadius: '10px!important',
    },
    inputText: {
      margin: '5px 0!important',
      padding: '6px 40px!important',
      height: '3.5em!important',
      width: '100%',
    },
    labelText: {
      fontSize: 15,
      marginTop: 5,
      marginBottom: -8,
      fontWeight: 550,
      color: '#a51713',
    },
    content: {
      marginBottom: '-19px!important',
    },
    title: {
      zIndex: 2,
      backgroundColor: '#a51614',
      padding: '12px 0',
      color: '#fff',
      fontSize: 16,
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      height: 50,
      width: '100%',
    },

    gridNameItemMenu: {
      zIndex: 2,
      backgroundColor: '#fff',
      cursor: 'pointer',
      width: '100%',
      padding: '0 20px',

      justifyContent: 'space-between!important',
    },
    nameItemMenu: {
      textTransform: 'uppercase',
      margin: 0,
      color: '#4d5055',
      fontSize: 18,
    },
  }),
);

export default useStyles;
